export const FIND_HOTSPOT_CATEGORY = {
  DECORATIVE: "DECORATIVE",
  DROPZONE: "DROPZONE",
};

export const FIND_HOTSPOT_ITEM_TYPE = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  ELLIPSE: "ELLIPSE",
  POLYGON: "POLYGON",
  RECTANGLE: "RECTANGLE",
};
